// Copyright (c) 2022 by Move Closer

import { ComputedRef, WritableComputedRef } from '@vue/composition-api'
import { VueConstructor } from 'vue'

import { ImageData, Price } from '../../../../contexts'

import {
  AbstractCheckControlModelType, AbstractCheckControlProps
} from '../../../../dsl/abstract/components/CheckControl/CheckControl.contracts'
import { FormControlModelType } from '../../../../dsl/abstract/general'

import { Default } from './versions/Default.vue'
import { Advanced } from './versions/Advanced.vue'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface VariantsSwitchProps<ModelType extends FormControlModelType = FormControlModelType> extends Pick<AbstractCheckControlProps<ModelType>, 'model'> {
  variants: Variant[]
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface Variant {
  identifier: string | ImageData
  identifierLabel: string
  isAvailable: boolean
  name: string
  slug: string
  price?: Price
  hasDiscount?: boolean
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface UseVariantSwitchProvides<ModelType> {
  checked: WritableComputedRef<AbstractCheckControlModelType<ModelType>>
  value: ComputedRef<ModelType>
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export enum VariantsSwitchType {
  Default = 'default',
  Advanced = 'advanced'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const variantsSwitchTypeRegistry: Record<string, VueConstructor> = {
  [VariantsSwitchType.Advanced]: Advanced,
  [VariantsSwitchType.Default]: Default
}
